// extracted by mini-css-extract-plugin
export var fadeIn = "_hw-1";
export var modalContent = "_hw-3";
export var overlay = "_hw-0";
export var popoverContent = "_hw-2";
export var results = "_hw-5";
export var searchInputWrapper = "_hw-4";